import type { VariantProps } from "class-variance-authority";
import React, { forwardRef } from "react";

import { buttonVariants } from "./button-variants";

interface ButtonProps
  extends VariantProps<typeof buttonVariants>,
    React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    className,
    pattern,
    size,
    variant,
    isInline,
    children,
    disabled,
    ...rest
  } = props;

  const classes = buttonVariants({
    pattern,
    size,
    variant,
    isInline,
    className,
  });

  return (
    <button
      aria-disabled={Boolean(disabled)}
      className={classes}
      disabled={disabled}
      ref={ref}
      {...rest}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };
export type { ButtonProps };
